import { makeStyles } from "@material-ui/core/styles";

export const quickwinCardStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "50px",
    "& svg": {
      marginRight: "10px",
    },
  },
  card: {
    padding: "24px",
    background: "#FFFFFF",
    border: "1px solid #A7BBD4",
    borderRadius: "8px",
    "&:hover": {
      background: "#ECF3F8",
      border: "1px solid #A7BBD4",
      boxShadow: "inset 0px -4px 0px #A7BBD4",
    },
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(22),
    color: "#000000",
  },
  statusDetails: {
    width: "125px",
    justifyContent: "space-around",
    display: "flex",
    alignItems: "center",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    padding: "4px 12px",
  },
  completed: {
    color: "#0C843C",
    background: "#E7F9EE",
    borderRadius: "100px",
  },
  notStarted: {
    color: "#45547C",
    background: "#E9EEF4",
    borderRadius: "100px",
  },
}));
